import {isSame, endOf, now} from 'stringdate';
import rqApi from '~/api';
import {useCountry} from '~/feature/country/CountryContext';
import {AU} from 'bigdatr-style';

export type MediaValueContext = NonNullable<ReturnType<typeof useMediaValueContext>>;

/** we have patchy creative data before this date for australia, and as a result we dont calculate
 * media value before this date as well */
export const earliestAustralianDate = '2017-01-01';
export const earliestNewZealandDate = '2024-01-01';

export function useMediaValueContext(options: {enabled: boolean}) {
    const request = rqApi.useGetForecastDates(options);
    const {country} = useCountry();
    if (request.isError) throw request.error;

    const {maxDate, forecastCutoff, forecastCutoffDigital} = request.data;
    const endDate = isSame('month', maxDate)(now()) ? now() : endOf('month')(maxDate);

    let startDate = earliestAustralianDate;
    if (country !== AU) {
        startDate = earliestNewZealandDate;
    }
    return {
        /** Earliest date you can select media value for */
        startDate,
        /** Latest date you can select media value for, including prelim data */
        endDate,
        /** Date when Traditional media value is locked in (Traditional = every media type
         * except Digital media types).
         *
         * If `forecastCutoff` is 2024-06-01, that means that May data is locked in for
         * traditional, but everything after May until `endDate` is prelim for traditional media
         * types */
        forecastCutoff,
        /** Date when Digital media value is locked in. If `forecastCutoffDigital` is
         * 2024-05-01, that means that April data is locked in for digital, but everything
         * after April until `endDate` is prelim for digital media types */
        forecastCutoffDigital
    };
}
